export enum WidthdrawBalanceStage {
    TMP_PICK_0 = 0,  
    ACCT_SETUP_1 = 1,
    ACCT_CONFIRM_2 = 2,
    ACCT_WAITING_3 = 3,
    ACCT_APPROVED_4 = 4,
    WITHDRAW_FORM_5 = 5,
    WITHDRAW_PENDING_6 = 6,
    WITHDRAW_SUBMITTED_7 = 7,
};